<template>
  <v-dialog
      v-model="showWebhookEditor"
      persistent
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Update URL Webhook</span>
      </v-card-title>
      <v-card-text class="py-0">
        <v-container>
          <v-form ref="form">
            <span>URL Webhook</span>
            <br/>
            <small>This is the address that will receive events from FPT AI</small>
            <v-text-field outlined dense v-model="currentApp['webhook_url']" :rules="formRules.required"></v-text-field>
            <small>Verification code</small>
            <v-text-field outlined dense v-model="verifyToken" :rules="formRules.required"></v-text-field>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
            depressed
            class="text-none"
            @click="showWebhookEditor = false"
        >
          Cancel
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            depressed
            class="text-none"
            @click="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {sync} from "vuex-pathify";
import {mapActions} from "vuex";
import FormMixin from "@/mixins/form.mixin"
import {ApplicationService} from "@/services";
import AppService from "@/services/app.service";

export default {
  name: "WebhookEditor",
  mixins: [FormMixin],
  data() {
    return {
      loading: false,
      verifyToken: ''
    }
  },
  computed: {
    showWebhookEditor: sync('dialogs/showWebhookEditor'),
    currentApp: sync('application/currentApp'),
  },
  methods: {
    ...mapActions('application', ['findOne']),
    submit() {
      if(this.$refs.form.validate()) {
        this.loading = true;
        ApplicationService.setWebhook(this.currentApp.id, {
          webhook_url: this.currentApp.webhook_url,
          verify_token: this.verifyToken
        })
        .then(() => {
          AppService.toastSuccess('Update webhook successfully')
        })
        .catch(() => {
          this.findOne()
          AppService.toastError('Update webhook failed')
        })
        .finally(()=> {
          this.loading = false
          this.showWebhookEditor = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
